<template>
  <div
    ref="scrollableContentWidth"
    class="lv-scrollable-block-content"
    :class="{
      small: small,
      bottom: bottom,
      noPadding: noPadding,
      alignCenter: alignCenter,
      transparent: transparent,
      paddingDefault: paddingDefault,
      'auto-height': isAutoHeight,
      'justify-content-center': justifyCenter,
    }"
  >
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    alignCenter: {
      type: Boolean,
      default: false,
    },
    paddingDefault: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    isAutoHeight: {
      type: Boolean,
      default: false,
    },
    justifyCenter: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    width: 0,
    leftPosition: 0,
  }),
  watch: {
    bottom: {
      deep: true,
      handler() {
        this.$_getBottomBarWidth();
      },
    },
  },
  created() {
    window.addEventListener("resize", this.$_getBottomBarWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.$_getBottomBarWidth);
  },
  mounted() {
    this.$_getBottomBarWidth();
  },
  methods: {
    $_getBottomBarWidth() {
      if (!this.bottom) return;
      if (!this.$refs.scrollableContentWidth) {
        return null;
      }
      let contnetWidth =
        this.$refs.scrollableContentWidth.getBoundingClientRect();
      this.width = contnetWidth.width;
      this.leftPosition = contnetWidth.x;
      let widthPosition = {
        width: this.width,
        position: this.leftPosition,
      };
      this.$emit("width-position-update", widthPosition);
    },
  },
};
</script>